/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function() {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    initNotifyForm() {
      const toggleNotifyPopin = (toggler) => {
        const productCardColumn = toggler.closest(".column");
        const notifyPopin = productCardColumn.querySelector(".elkad-notify-when-out-of-stock-popin");
      
        const variantSelector = notifyPopin.querySelector(".elkad-notify-when-out-of-stock-popin__select");
        if (productCardColumn) {
          productCardColumn.style = "";
          notifyPopin.style = "";
        }
        if (variantSelector) {
          variantSelector.value = notifyPopin.getAttribute("data-variant-id");
        }
        notifyPopin.classList.toggle("elkad-notify-when-out-of-stock-popin--hidden");

        document.body.classList.toggle("open-cc--elkad");
      }

      const notifyTogglers = document.querySelectorAll(".js-notify-toggler");

      notifyTogglers.forEach(toggler => {
        if (!toggler.classList.contains("elkad-notify-when-out-of-stock-popin-init")) {
          toggler.addEventListener("click", () => {
            toggleNotifyPopin(toggler);
          });
          toggler.classList.add("elkad-notify-when-out-of-stock-popin-init");
        }
      });

      const allProductCards = document.querySelectorAll(".product-card.product-card--out-of-stock");
      
      allProductCards.forEach(card => {
        const notifyPopin = card.nextElementSibling.classList.contains("elkad-notify-when-out-of-stock-popin") ? card.nextElementSibling : null;
        
        if (notifyPopin && !notifyPopin.classList.contains("elkad-init")) {
          const variantSelector = notifyPopin.querySelector(".elkad-notify-when-out-of-stock-popin__select");
          const submitNotify = notifyPopin.querySelector(".elkad-submit");
          const notifyInput = notifyPopin.querySelector("input[type='email']");
  
          const handleNotifyButton = () => {
            if (!submitNotify) return;
  
            submitNotify.addEventListener("click", () => {
              const idValue = variantSelector ? variantSelector.value : notifyPopin.getAttribute("data-variant-id");
              BIS.create(notifyInput.value, idValue, notifyPopin.getAttribute("data-product-id"))
              .then(function(resp) {
                const response = resp.status == 'OK' ? resp.message : resp.errors;
  
                if (resp.status == 'OK') {
                  notifyPopin.querySelector(".form-notification span").innerHTML = response;
                  notifyPopin.querySelector(".form-notification").classList.remove("error");
                  notifyPopin.querySelector(".form-notification").classList.add("success");
                } else {
                  notifyPopin.querySelector(".form-notification span").innerHTML = '';
                  if (response.email) {
                    response.email.forEach(error => {
                      notifyPopin.querySelector(".form-notification span").insertAdjacentHTML("beforeend", `${error}<br>`);
                    });
                  }
                  if (response.base) {
                    response.base.forEach(error => {
                      notifyPopin.querySelector(".form-notification span").insertAdjacentHTML("beforeend", `${error}<br>`);
                    });
                  }
                  if (response.variant_no) {
                    response.variant_no.forEach(error => {
                      notifyPopin.querySelector(".form-notification span").insertAdjacentHTML("beforeend", `${error}<br>`);
                    });
                  }
                  notifyPopin.querySelector(".form-notification").classList.remove("success");
                  notifyPopin.querySelector(".form-notification").classList.add("error");
                }
              });
            });
  
            notifyPopin.classList.add("elkad-init");
          }
  
          handleNotifyButton();
        }
      });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
      this.initNotifyForm();
    }
    
  }
  customElements.define('pagination-theme', Pagination);
}